import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * A student's class label: "CSM-A", or just "CSM" when no section is on record
 * (AERO/EEE/MECH/CSIT run a single section) and '' when neither is known.
 */
export function deptSection(department?: string | null, section?: string | null) {
  return [department, section].filter(Boolean).join('-');
}
